<div class="absolute flex hidden sm:block">
  <svg
    width="380px"
    height="430px"
    viewBox="0 0 128 128"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
    role="img"
    class="iconify iconify--noto"
    preserveAspectRatio="xMidYMid meet"
  >
    <path
      d="M97.36 62.59s4.5-9.71 4.01-18.37c-.32-5.56.92-29.63-35.69-30.34c-36.6-.7-38.86 20.74-38.86 31.25c0 7.88 3.52 15.35 3.52 15.35s-2.96-.7-6.34 3.24s-3.54 12.47-1.13 17.18c3.03 5.91 8.02 9.29 8.02 9.29l10.42 15.35s-1.55 4.29-4.22 7.46c-1.8 2.14-5.58 5.46-5.49 6.76c.14 1.97 4.22.99 10.14 1.27c5.91.28 22.67-2.53 22.67-2.53l25.06 1.55c2.25.14 7.11.49 7.74-.99c.39-.91-3.42-4.2-5-7.04c-2.04-3.66-3.31-9.43-3.31-9.43s4.65-9.71 6.62-11.26c1.97-1.55 7.46-8.45 9.01-12.11s2.11-10.56-1.13-13.8c-2.4-2.43-6.04-2.83-6.04-2.83z"
      fill="#6e4f44"
    ></path>
    <path
      d="M86.17 19.51s2.11-4.5 6.34-7.25c3.9-2.53 8.52-2.25 8.87-1.9c.35.35-.54 3.68-2.11 5.91c-1.34 1.9-2.75 3.38-2.53 3.59c.39.39 1.72-1.33 3.45-2.75c2.32-1.9 5.35-2.6 5.7-2.32s.84 5.35-1.41 9.64c-2.11 4.01-5.98 6.55-5.98 6.55l-5.42-7.32l-6.91-4.15z"
      fill="#6e4f44"
    ></path>
    <path
      d="M44.28 19.01s-2.53-5.21-5.56-8.31s-7.74-4.86-8.31-4.29s-.49 4.01.21 6.26s2.82 4.5 2.18 4.93c-.63.42-1.73-2.13-2.82-3.31c-1.76-1.9-4.93-3.45-5.49-3.1c-.56.35-1.9 5.7.77 10.63c2.37 4.37 5.84 8.45 5.84 8.45l8.17-7.81l5.01-3.45z"
      fill="#6e4f44"
    ></path>
    <path
      d="M46.96 111.06s-.5 2.08-3.1 4.41c-2.96 2.65-7.98 6.1-4.79 7.23c3.19 1.13 7.7 1.13 12.39.19s9.29-2.35 12.58-2.35c3.28 0 9.95 1.22 13.23 1.69c3.28.47 7.47.88 9.85.38c2.21-.47 3.26-1.45-.54-5.4c-1.63-1.69-4.43-6.43-4.43-6.43l-18.96 3.1l-16.23-2.82z"
      fill="#878787"
    ></path>
    <path
      d="M36.45 61.41s-3.85.38-5.44 2.53s-3.75 8.26-3.38 16.89c.38 8.63 4.13 15.96 9.01 22.43c4.88 6.48 11.54 13.05 26.65 12.58c15.11-.47 22.99-4.32 26.94-11.26c3.94-6.95 8.82-16.14 9.29-24.78c.47-8.63-3.85-16.52-5.26-17.55c-1.41-1.03-30.5-2.44-30.5-2.44l-27.31 1.6z"
      fill="#875d54"
    ></path>
    <linearGradient
      id="IconifyId17ecdb2904d178eab14736"
      gradientUnits="userSpaceOnUse"
      x1="63.407"
      y1="60.819"
      x2="63.716"
      y2="110.686"
    >
      <stop offset=".05" stop-color="#f5dbb8"></stop>
      <stop offset=".238" stop-color="#f2d2af"></stop>
      <stop offset=".547" stop-color="#e9b996"></stop>
      <stop offset=".894" stop-color="#dc9673"></stop>
    </linearGradient>
    <path
      d="M42.17 61.41s-9.29 8.35-7.6 22.99c1.49 12.92 10.7 26.19 28.81 26.28c20.56.11 28.14-14.57 29.19-26.47c1.22-13.89-6.66-22.34-7.7-23.18c-1.03-.84-42.7.38-42.7.38z"
      fill="url(#IconifyId17ecdb2904d178eab14736)"
    ></path>
    <path
      d="M64.23 73.43s8.07-8.54 14.45-10.23c6.38-1.69 15.58-.94 15.58-.94s4.29-6.43 4.6-18.77c.33-13.25-6.66-18.96-6.66-18.96s-11.64-2.25-19.71 6.19c-6.76 7.07-5.91 15.58-5.91 15.58l-3.64-.61s.05-9.46-6.62-15.27s-15.84-7.3-15.84-7.3s-11.14 5.95-11.4 19.69c-.28 14.73 5.28 18.93 5.28 18.93s9.03.23 17.01 3.05s12.86 8.64 12.86 8.64z"
      fill="#f2a35b"
    ></path>
    <path
      d="M93.23 42.83c0 7.3-3.93 12.97-12.11 13.89c-8.86 1-13.24-5.75-13.24-13.05s5.67-13.22 12.67-13.22s12.68 5.08 12.68 12.38z"
      fill="#d0805f"
    ></path>
    <path
      d="M59.65 36.6c3.63 6.6 2.18 16.37-3.87 18.99c-7.13 3.1-14.67.03-18.3-6.57s-1.23-14.14 4.9-17.51S56.02 30 59.65 36.6z"
      fill="#d0805f"
    ></path>
    <path
      d="M78.35 73.14c1.67.37 2.53-2.82 4.46-1.27c1.92 1.55-.8 4.5-3.8 4.6c-3 .09-6.24-1.97-5.12-3.94c1.13-1.97 2.54.19 4.46.61z"
      fill="#d0805f"
    ></path>
    <path
      d="M85.49 81.26c2.39-.23 3.57-2.91 5.16-1.27s-.99 4.46-5.02 4.69c-4.04.23-6.19-1.83-5.3-3.43c.89-1.58 2.29.29 5.16.01z"
      fill="#d0805f"
    ></path>
    <path
      d="M64.6 82.34c2.95.17 3.14-2.82 5.3-1.78c2.16 1.03-.37 5.53-5.02 5.49c-5.26-.05-7.17-3.88-5.73-5.07c2.07-1.69 2.26 1.17 5.45 1.36z"
      fill="#d0805f"
    ></path>
    <path
      d="M50.24 73.94c2.02-.12 1.69-2.63 4.41-1.69c2.3.8-.33 5.21-4.74 5.16c-3.94-.04-6.1-3.33-5.02-4.32c2.14-1.94 3.01.99 5.35.85z"
      fill="#d0805f"
    ></path>
    <path
      d="M41.42 81.17c1.74-.05 2.11-2.35 4.04-1.22c1.92 1.13.28 4.74-4.18 4.79c-3.99.04-5.46-2.73-4.36-3.94c1.69-1.88 2.77.42 4.5.37z"
      fill="#d0805f"
    ></path>
    <path
      d="M70.52 45.13c1.45 4.58 6.87 7.03 11.73 5.49s7.38-6.41 5.82-11.4c-1.77-5.66-6.91-6.84-11.78-5.3c-4.87 1.53-7.23 6.62-5.77 11.21z"
      fill="#fffeff"
    ></path>
    <path
      d="M41.75 35.88c-2.87 3.86-2.5 9.25 1.6 12.29s9.63 3.25 12.76-.94c3.56-4.75 2.07-9.95-2.02-13s-9.47-2.2-12.34 1.65z"
      fill="#fffeff"
    ></path>
    <path
      d="M84.78 39.76c1.2 3.06.12 6.56-3.04 7.81c-3.17 1.25-7.21-.23-8.42-3.29c-1.2-3.06.09-6.62 3.26-7.88c3.42-1.36 6.99.3 8.2 3.36z"
      fill="#303232"
    ></path>
    <path
      d="M54.98 44.52c-1.63 2.85-6.01 3.71-9.39 1.55c-2.87-1.83-3.09-5.59-1.45-8.45c1.63-2.85 5.36-3.33 8.49-2.02c3.81 1.6 3.99 6.07 2.35 8.92z"
      fill="#303232"
    ></path>
    <path
      d="M59.39 46.11s-.16 6.1 0 8.17c.23 2.96.86 5.09 1.74 6.85c.94 1.88 2.35 3.94 3.05 3.94c.7 0 2.16-1.99 3-3.89c.7-1.6 1.45-3.75 1.78-7.46c.28-3.15.28-6.95.28-6.95l-9.85-.66z"
      fill="#2f2f2f"
    ></path>
    <path
      d="M64.23 40.58c3.24-.07 4.18 1.92 4.88 3.61c.42 1.01.7 3.1.42 3.47c-.28.38-2.72.99-4.93.99s-5.91-.8-5.96-1.41c-.05-.61.56-2.89 1.17-3.8c1.13-1.69 2.21-2.82 4.42-2.86z"
      fill="#feb903"
    ></path>
  </svg>
</div>
<div class="relative bg-white bg-opacity-75 overflow-hidden">
  <svg #svg [attr.width]="width" [attr.height]="height" class="w-full h-auto max-w-full">
    <g></g>
  </svg>
</div>
